import { useState, useEffect } from 'react';

const navItems = [
  { label: 'Ana Sayfa', href: '#hero' },
  { label: 'Hakkımızda', href: '#hakkimizda' },
  { label: 'Markalar', href: '#markalar' },
  { label: 'Yedek Parça', href: '#yedek-parca' },
  { label: 'Hizmetlerimiz', href: '#hizmetler' },
  { label: 'İletişim', href: '#iletisim' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNav = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <header
      className={`fixed top-0 left-0 w-full z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-white/95 backdrop-blur-md border-b border-gray-200'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 flex items-center justify-between h-20">
        {/* Logo */}
        <a
          href="#hero"
          onClick={(e) => { e.preventDefault(); handleNav('#hero'); }}
          className="flex items-center gap-3 cursor-pointer"
        >
          <img
            src="https://ilkeismakinalari.com/img/ilke-logo.png"
            alt="İlke İş Makinaları Logo"
            className="h-20 w-auto object-contain"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => { e.preventDefault(); handleNav(item.href); }}
              className="text-sm font-medium text-gray-600 hover:text-orange-500 transition-colors duration-200 cursor-pointer whitespace-nowrap tracking-wide"
            >
              {item.label}
            </a>
          ))}
          <a
            href="#iletisim"
            onClick={(e) => { e.preventDefault(); handleNav('#iletisim'); }}
            className="border border-orange-500 text-orange-500 hover:bg-orange-500 hover:text-white text-sm font-semibold px-5 py-2.5 rounded-sm transition-all duration-200 whitespace-nowrap cursor-pointer tracking-wider uppercase text-xs"
          >
            Teklif Al
          </a>
        </nav>

        {/* Mobile Hamburger */}
        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer text-gray-700"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Menü"
        >
          <i className={`text-2xl ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
        </button>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden bg-white border-t border-gray-200">
          <nav className="flex flex-col px-4 py-4 gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNav(item.href); }}
                className="text-gray-700 hover:text-orange-500 font-medium py-3 border-b border-gray-100 cursor-pointer text-sm tracking-wide"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#iletisim"
              onClick={(e) => { e.preventDefault(); handleNav('#iletisim'); }}
              className="mt-3 border border-orange-500 text-orange-500 text-center py-3 rounded-sm font-semibold cursor-pointer text-sm uppercase tracking-wider"
            >
              Teklif Al
            </a>
          </nav>
        </div>
      )}
    </header>
  );
}
